<dashboardnav>
  <cradua-lessor-rep-type [lessorreptypes]="lessorreptypes$ | async" (lessorreptype)="onSubmitLessorRepType($event)"
    (deleteLessorRepTypeEvent)="onDeleteLessorRepType($event)" *ngIf="(isLoadingLessorRepType$ | async ) === false">
  </cradua-lessor-rep-type>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingLessorRepType$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
